{
  const FORM_SELECTOR = '.vip-app-point-use-form-block';
  const POLL_INTERVAL_MS = 400;
  const POLL_TIMEOUT_MS = 6000;

  async function fetchTotalDiscount() {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await res.json();
      return cart.total_discount || 0;
    } catch (_) {
      return null;
    }
  }

  async function waitForCartChange(initial) {
    const deadline = Date.now() + POLL_TIMEOUT_MS;
    while (Date.now() < deadline) {
      const current = await fetchTotalDiscount();
      if (current !== null && current !== initial) return true;
      await new Promise((r) => setTimeout(r, POLL_INTERVAL_MS));
    }
    return false;
  }

  document.addEventListener('click', async (e) => {
    const button = e.target.closest(`${FORM_SELECTOR} button`);
    if (!button) return;

    const before = await fetchTotalDiscount();
    if (before === null) return;

    const changed = await waitForCartChange(before);
    if (changed) window.location.reload();
  });

  document.addEventListener('click', async (e) => {
    const removeBtn = e.target.closest('[data-vip-points-remove]');
    if (!removeBtn || removeBtn.disabled) return;
    e.preventDefault();
    removeBtn.disabled = true;
    const originalText = removeBtn.textContent;
    removeBtn.textContent = '解除中…';
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: '' }),
        credentials: 'same-origin'
      });
      window.location.reload();
    } catch (_) {
      removeBtn.disabled = false;
      removeBtn.textContent = originalText;
    }
  });
}
